import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  NEXT_BUTTON: `${cleanedFilename(__filename)}-next-button`,
  VALIDATE_BUTTON: `${cleanedFilename(__filename)}-validate-button`,
};
